module.exports = __webpack_public_path__ + "img/optical-sensor.706494ec.png";